module.exports = "agm-map {\r\n  height: 300px;\r\n}\r\n"